// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"d0a1578d","354":"3a25e5a6","838":"580e6b4f"}[chunkId] + ".js";
};